"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
function UndoRedoMenuItem({ onClick, children }) {
    const theme = (0, styled_components_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(MenuButton, { onClick: onClick, "data-e2e": 'UndoRedoMenuItem_MenuButton', children: [children, (0, jsx_runtime_1.jsx)(ui_1.Ripple, { color: theme.ripple, duration: 700, "data-e2e": 'UndoRedoMenuItem_Ripple' })] }));
}
exports.default = UndoRedoMenuItem;
const MenuButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  position: relative;
  width: 100%;
  margin: 0;
  font-size: 11px;

  background: ${({ theme }) => theme.textPlaceholderWithOpacity};
  border-top: 1px solid ${({ theme }) => theme.textPlaceholderWithOpacity};
  color: ${({ theme }) => theme.textSecondary};
`;
